var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBarChart = function SvgBarChart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 19v-6c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C5.398 10 4.932 10 4 10c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C1 11.602 1 12.068 1 13v2.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 19 3.08 19 4.2 19H7Zm0 0h6m-6 0V4c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C8.602 1 9.068 1 10 1c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C13 2.602 13 3.068 13 4v15m0 0h2.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 17.48 19 16.92 19 15.8V9c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C17.398 6 16.932 6 16 6c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C13 7.602 13 8.068 13 9v10Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBarChart);
export default ForwardRef;